import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { Layer } from 'bernie-view';
import { QueryRoute, RouteStore } from 'bernie-core';

import { HotelMapModel } from 'models/hotel/map-types';
import { OverviewViewModel } from 'models';

// Components
import { QueuedImage } from 'components/common/media/queued-image';
import { MapAddressLine } from 'components/infosite/property-details/property-map/map-address-line';
import { MapDialog } from 'components/infosite/property-details/property-map/map-dialog';

const LinkTracked = ClickTracker(Link);

interface MapTriggerState {
  mapActive: boolean;
}

interface MapTriggerProps {
  routeStore?: RouteStore;
  mapModel: HotelMapModel;
  src?: string;
  className?: string;
  label?: string;
  alt: string;
  overview?: OverviewViewModel;
}

@inject('routeStore')
@observer
export class MapTrigger extends React.Component<MapTriggerProps, MapTriggerState> {
  private mapBtn: any;

  constructor(props) {
    super(props);

    this.state = {
      mapActive: false
    };

    this.onMapDialogClose = this.onMapDialogClose.bind(this);
  }

  public shouldComponentUpdate(nextState) {
    return this.state.mapActive !== nextState.mapActive;
  }

  public componentDidMount() {
    this.setState({
      mapActive: true
    });
  }

  public render() {
    const { routeStore } = this.props;
    const mapBtn = m => {
      this.mapBtn = m;
    };
    const searchName = this.props.src ? 'map' : 'address';
    const mapOpenQuery = this.props.routeStore.mergeQueryString(routeStore.search, { pwaDialog: searchName });
    const extraProps = this.state.mapActive ? { innerRef: mapBtn } : {};
    const classList = this.props.src ? ['map'] : ['address', 'uitk-type-left'];

    if (this.props.className) {
      classList.push(this.props.className);
    }

    if (this.state.mapActive) {
      return (
        <React.Fragment>
          <LinkTracked
            className={classList.join(' ')}
            disabled={!this.state.mapActive || null}
            linkName="Click static map"
            rfrr={this.props.src ? 'Map.StaticMap' : 'ClickAddressViewMap'}
            to={{ pathname: routeStore.pathname, search: mapOpenQuery }}
            {...extraProps}
          >
            {this.props.src && (
              <QueuedImage
                className="map__image image-loader image-loader__no-scrim"
                src={this.props.src}
                useBackgroundImage={true}
                serverRender={true}
              />
            )}
            {!this.props.src && <MapAddressLine overview={this.props.overview} />}
            <span className="is-visually-hidden">{`${this.props.mapModel.title} Map`}</span>
          </LinkTracked>
          <QueryRoute query={{ pwaDialog: searchName }}>
            <Layer id="infosite-map" onDismiss={this.onMapDialogClose}>
              <MapDialog mapModel={this.props.mapModel} onDismiss={this.onMapDialogClose} />
            </Layer>
          </QueryRoute>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          {this.props.src && (
            <QueuedImage
              className="map__image image-loader image-loader__no-scrim is-disabled"
              src={this.props.src}
              useBackgroundImage={true}
              serverRender={true}
            />
          )}
          {!this.props.src && <MapAddressLine className="uitk-link is-disabled" overview={this.props.overview} />}
        </React.Fragment>
      );
    }
  }

  private onMapDialogClose() {
    this.props.routeStore.goBack();

    if (this.mapBtn && typeof this.mapBtn.focus === 'function') {
      this.mapBtn.focus();
    }
  }
}
